import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

function Field({ label, children, hint }) {
  return (
    <div className="space-y-1">
      <Label className="text-sm font-medium">{label}</Label>
      {children}
      {hint && <p className="text-xs text-gray-400">{hint}</p>}
    </div>
  );
}

export default function WifiWhatsappSettings({ form, set }) {
  const enabled = form.wifi_whatsapp_send_enabled !== false;
  return (
    <section className="space-y-4">
      <h3 className="font-semibold text-gray-700">Automação WhatsApp</h3>
      <div className="flex items-center justify-between p-4 border rounded-lg bg-gray-50">
        <div>
          <p className="font-medium">Enviar clave Wi-Fi por WhatsApp</p>
          <p className="text-sm text-gray-500">
            Envia automaticamente a senha ao número do cliente após o registo
          </p>
        </div>
        <Switch checked={enabled} onCheckedChange={(v) => set("wifi_whatsapp_send_enabled", v)} />
      </div>
      {enabled && (
        <Field
          label="Mensagem personalizada (opcional)"
          hint="Use {restaurant_name} · {wifi_ssid} · {wifi_password}. Deixe em branco para a mensagem padrão."
        >
          <Textarea
            value={form.wifi_whatsapp_message_template || ""}
            onChange={(e) => set("wifi_whatsapp_message_template", e.target.value)}
            rows={4}
            placeholder={"🍣 {restaurant_name}\n\nTu acceso Wi-Fi ya está listo.\n\n📶 Red: {wifi_ssid}\n\n🔑 Clave: {wifi_password}"}
          />
        </Field>
      )}
    </section>
  );
}
